export enum MarketOrdering {
  newestFirst = '-date_created',
  oldestFirst = 'date_created',
  highestPrice = '-price',
  lowestPrice = 'price',
  closestDue = '-expiration_time',
  furthestDue = 'expiration_time',
  relevance = '-relevance',
  bestYield = 'best_yield',
  yieldAsc = 'yield_asc',
  activeSharesAsc = 'active_shares_asc',
  activeSharesDesc = 'active_shares_desc',
  deltaVsLastSale = 'delta_vs_last_sale',
  ownedSharesAsc = 'owned_shares_asc',
  ownedSharesDesc = 'owned_shares_desc',
  incomeTotalDesc = 'income_total_desc',
  incomeTotalAsc = 'income_total_asc',
  incomePerShareDesc = 'income_per_share_desc',
  incomePerShareAsc = 'income_per_share_asc',
  estValueDesc = 'est_value_desc',
  valuePerShareDesc = 'value_per_share_desc',
  currentPriceDesc = 'current_price_desc',
  currentPriceAsc = 'current_price_asc',
  vipPointsAsc = 'vip_points_asc',
  vipPointsDesc = 'vip_points_desc',
}
